import React, { useState, useEffect } from "react";
import cx from "classnames";
import { convertSnakeToTitleCase } from "../../utils";
import ArticleDifficultyLevelSelector from "../ArticleDifficultyLevelSelector";

const FiltrationCard = ({
  selectedTopic,
  selectedArticleCategories,
  setSelectedArticleCategories,
  selectedPodcastCategories,
  setSelectedPodcastCategories,
  selectedLevel,
  setSelectedLevel,
  applyFilters,
  resetFilters,
  iconFilter,
  isThai,
}) => {
  const [topic, _setTopic] = useState(selectedTopic);

  useEffect(() => {
    _setTopic(selectedTopic);
  }, [selectedTopic]);

  const renderCategories = (selectedCategories = {}, setSelectedCategories) => {
    return Object.entries(selectedCategories).map(([category, isActive]) => (
      <button
        key={`btn-category-${category}`}
        className={cx("button rounded-pill m-1", {
          active: isActive,
        })}
        onClick={() => {
          setSelectedCategories({
            ...selectedCategories,
            [category]: !isActive,
          });
        }}
      >
        {convertSnakeToTitleCase(category)}
      </button>
    ));
  };

  return (
    <div className="filtration">
      <div id="filtration-accordion" className="accordion">
        <div
          className="card-header d-md-flex"
          id="filtration-header"
          data-toggle="collapse"
          data-target="#filtration-collapse"
          aria-controls="filtration-collapse"
          aria-expanded="true"
        >
          <div className="title d-flex py-2 py-md-0 px-3 px-xl-2 align-items-center text-dark">
            Filter
            <img
              className="ml-1"
              src={iconFilter}
              alt="filter"
              height="16"
              width="16"
            />
            <div className="d-none d-md-block divider ml-4" />
          </div>

          <div className={cx("catalog d-flex", { "catalog--center": isThai })}>
            {isThai && (
              <button
                className={cx("button px-3 px-md-4 mx-0", {
                  active: topic === "all",
                })}
                onClick={(e) => {
                  e.stopPropagation();
                  _setTopic("all");
                }}
              >
                All
              </button>
            )}

            <button
              className={cx("button px-3 px-md-4 mx-0", {
                active: topic === "articles",
              })}
              onClick={(e) => {
                if (isThai) {
                  e.stopPropagation();
                  _setTopic("articles");
                }
              }}
            >
              Articles
            </button>

            {isThai && (
              <button
                className={cx("button px-3 px-md-4 mx-0", {
                  active: topic === "podcasts",
                })}
                onClick={(e) => {
                  e.stopPropagation();
                  _setTopic("podcasts");
                }}
              >
                Podcasts
              </button>
            )}
          </div>
        </div>

        <div
          id="filtration-collapse"
          className="accordion-collapse collapse show"
          aria-labelledby="filtration-header"
          data-parent="#filtration-accordion"
        >
          <div className="card-body">
            <div className="row px-3">
              <div
                className={cx("px-xl-0", {
                  "d-none": topic === "podcasts",
                  "col-xl-4": topic === "all",
                  "col-xl-8": topic !== "all",
                })}
              >
                <div className="card-body__header px-xl-2">ARTICLES</div>
                <div className="card-body__category mb-3 px-xl-1">
                  {renderCategories(
                    selectedArticleCategories,
                    setSelectedArticleCategories
                  )}
                </div>
              </div>
              <div
                className={cx("px-xl-0", {
                  "d-none": topic === "articles",
                  "col-xl-4": topic === "all",
                  "col-xl-8": topic !== "all",
                })}
              >
                <div className="card-body__header px-xl-2">PODCASTS</div>
                <div className="card-body__category mb-3 px-xl-1">
                  {renderCategories(
                    selectedPodcastCategories,
                    setSelectedPodcastCategories
                  )}
                </div>
              </div>
              <div className={cx("col-xl-4 px-xl-0")}>
                <div className="card-body__header px-xl-2">DIFFICULTY</div>
                <div className="card-body__category mb-3 px-xl-1">
                  <ArticleDifficultyLevelSelector
                    selectedLevel={selectedLevel}
                    setSelectedLevel={setSelectedLevel}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-end my-2 pr-3 pr-xl-4">
              <button
                className="button btn-reset mr-3"
                onClick={() => {
                  resetFilters();
                  _setTopic("all");
                }}
              >
                Reset
              </button>
              <button
                className="button button-primary"
                onClick={() => applyFilters(topic)}
              >
                Apply Filters
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FiltrationCard;
